<template>
    <div>
        <h4 class="mb-3">Profils</h4>
        <div class="border p-3">
            <div class="row">
                <div class="col-sm-4">
                    <h6 class="mt-0 mb-4">Pamatinfo</h6>
                    <div class="mb-3">
                        <label for="name" class="d-block text-secondary text-left mb-0">Vārds</label>
                        <input type="text" id="name" disabled class="ds-input d-block w-100" :value="currentUser.name">
                    </div>
                    <div class="mb-3">
                        <label for="surname" class="d-block text-secondary text-left mb-0">Uzvārds</label>
                        <input type="text" id="surname" disabled class="ds-input d-block w-100" :value="currentUser.surname">
                    </div>
                    <div class="mb-3">
                        <label for="role" class="d-block text-secondary text-left mb-0">Amats</label>
                        <input type="text" id="role" disabled class="ds-input d-block w-100" :value="currentUser.jobTitleIdentifier">
                    </div>
                    <div class="mb-3">
                        <label for="email" class="d-block text-secondary text-left mb-0">Epasts</label>
                        <input type="text" id="email" disabled class="ds-input d-block w-100" :value="currentUser.email">
                    </div>
                    <div class="mb-3">
                        <label for="username" class="d-block text-secondary text-left mb-0">Lietotājvārds</label>
                        <input type="text" id="username" disabled class="ds-input d-block w-100" :value="currentUser.username">
                    </div>
                </div>
                <div class="offset-sm-1 col-sm-5">
                    <h6 class="mt-0 mb-4">Darbības</h6>
                    <font-awesome-icon icon="user-secret"/>
                    <router-link
                    class="text-dark d-inline-block ml-2 mb-4"
                    :to="{name: 'user-password-change'}">
                        Veikt paroles maiņu
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'user-profile',
        computed: mapGetters('auth', {
            /** @type {CurrentUser|*} */
            currentUser: authStoreTypes.GET_CURRENT_USER,
        })

    }
</script>